import React from 'react';
import { PresentationSlide, slideSize } from '../types';
import StaticSlideView from '../editor/StaticSlideView';
import ThumbnailFrame from './ThumbnailFrame';

interface SlideThumbnailProps {
  slide?: PresentationSlide | null;
  selected?: boolean;
  hidden?: boolean;
  pageFormat?: string | null;
  onClick?: (event: React.MouseEvent) => void;
  onDoubleClick?: (event: React.MouseEvent) => void;
  onContextMenu?: (event: React.MouseEvent) => void;
}

const SlideThumbnail: React.FC<SlideThumbnailProps> = ({
  slide,
  selected,
  hidden,
  pageFormat,
  onClick,
  onDoubleClick,
  onContextMenu,
}) => (
  <ThumbnailFrame
    selected={selected}
    hidden={hidden}
    ratio={slideSize(pageFormat).aspectRatio}
    onClick={onClick}
    onDoubleClick={onDoubleClick}
    onContextMenu={onContextMenu}
  >
    {slide ? <StaticSlideView slide={slide} pageFormat={pageFormat} /> : null}
  </ThumbnailFrame>
);

export default SlideThumbnail;
